export interface CheckboxColors {
  selectedBackground?: string | null;
  selectedBorder?: string | null;
}

export function buildCheckboxCssRules(
  s: string,
  colors: CheckboxColors | null | undefined,
): string[] {
  if (!colors) {
    return [];
  }

  const bg = colors.selectedBackground || undefined;
  const border = colors.selectedBorder || undefined;

  if (!bg && !border) {
    return [];
  }

  const selectors = [
    `${s}[data-ui="item-checkbox"]`,
    `${s}[data-ui="bundle-group-checkbox"]`,
    // Selection-card-like radio card surfaces reuse the same tokens for their
    // selected bubble state.
    `${s}[data-ui="option"]`,
    `${s}[data-ui="order-selection-option"]`,
    `${s}[data-selection-card]`,
  ];
  const selectorList = selectors.join(", ");

  // bg / hover tokens are safe to set on the whole card subtree — they only
  // affect the radio bubble's fill and the card's hover/selected ring.
  const cardLevelVars: string[] = [];
  if (bg) {
    cardLevelVars.push(`--redo-colors-background-bg-alternate: ${bg};`);
    cardLevelVars.push(`--redo-colors-background-bg-secondary-solid: ${bg};`);
    cardLevelVars.push(`--redo-colors-text-text-secondary_hover: ${bg};`);
  }
  if (border) {
    // The border color also controls the checkmark icon color (renders inside
    // the checked bubble).
    cardLevelVars.push(`--redo-colors-foreground-fg-on-brand: ${border};`);
  }

  const rules: string[] = [];
  if (cardLevelVars.length > 0) {
    rules.push(`${selectorList} { ${cardLevelVars.join(" ")} }`);
  }

  if (border) {
    // Checkbox borders stay neutral; selected secondary only themes radio
    // borders and the selected control's checkmark/dot color.
    const radioBubbleSelectors = selectors
      .map((sel) => `${sel} input[type="radio"] + div`)
      .join(", ");
    rules.push(
      `${radioBubbleSelectors} { --redo-colors-border-border-primary: ${border}; }`,
    );
  }

  return rules;
}
